<script>
	export default {
		name: 'parceiros'
	}
</script>

<template>
	<div id="parceiros" class="row">
		<div class="container">
			<section class="section">
				<h2 class="title">PARCEIROS</h2>
				<div class="parceiros-wrap">
					<div class="parceiro margin-ajust">
						<div class="img-content">
							<a href="http://www.mcce.org.br/" target="_blank"><img src="../../img/parceiros/logo-mcce.png" alt="MCCE"></a>
						</div>
					</div>

					<div class="parceiro margin-ajust">
						<div class="img-content">
							<a href="https://www.catarse.me/" target="_blank"><img src="../../img/parceiros/catarse.png" alt="Catarse"></a>
						</div>
					</div>

					<div class="parceiro">
						<div class="img-content">
							<a href="https://www.ciclocidade.org.br/" target="_blank"><img src="../../img/parceiros/ciclo-cidade.png" alt="Ciclo Cidade"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="https://cidadeape.org/" target="_blank"><img src="../../img/parceiros/cidade-a-p.png" alt="Cidade a p"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="https://cidadedossonhos.org/" target="_blank"><img src="../../img/parceiros/cidade-dos-sonhos.png" alt="Cidade dos sonhos"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="http://cidadesparapessoas.com/" target="_blank"><img src="../../img/parceiros/cidades-para-pessoas.png" alt="Cidade para pessoas"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="http://www.dadocapital.com/" target="_blank"><img src="../../img/parceiros/dado-capital.png" alt="Dado capital"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="https://br.okfn.org/" target="_blank"><img src="../../img/parceiros/open-knowledge.png" alt="Open konwledge"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="http://www.paiolfilmes.com.br/" target="_blank"><img src="../../img/parceiros/paiol.png" alt="Paiol"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="http://www.politize.com.br/" target="_blank"><img src="../../img/parceiros/politize.png" alt="politize"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="http://www.questtono.com/" target="_blank"><img src="../../img/parceiros/questto.png" alt="Questto"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="https://www.raps.org.br/" target="_blank"><img src="../../img/parceiros/raps.png" alt="raps"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="https://github.com/thacker" target="_blank"><img src="../../img/parceiros/transparencia-hacker.png" alt="Transparencia hacker"></a>
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<img src="../../img/parceiros/update.png" alt="Update">
						</div>
					</div>
					<div class="parceiro">
						<div class="img-content">
							<a href="https://www.w3.org/" target="_blank"><img src="../../img/parceiros/w-3-c.png" alt="W3c"></a>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<style lang="scss" scoped>

#parceiros {
  background-color: #4bb958;
  padding-top: 100px;
}
#parceiros .parceiros-wrap {
  position: relative;
  overflow: hidden;
  text-align: center;
}
#parceiros .parceiro {
  display: inline-block;
  margin-bottom: 30px;
  margin: 20px;
  background-color: #fff;
  border-radius: 15px;
}
#parceiros .img-content {
  width: 150px;
  height: 150px;
  object-fit: contain;
  overflow: hidden;
  margin: 20px 30px 20px 30px;
  display: inline-block;
}
#parceiros .img-content a {
	display: block;
}
#parceiros .img-content img {
  width: 100%;
  display: inline-block;
}


</style>



// WEBPACK FOOTER //
// _source/javascript/components/parceiros.vue